import React, { useState, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import {
  Anchor,
  Calendar,
  MapPin,
  CreditCard,
  ChevronRight,
  CheckCircle2,
  AlertCircle
} from "lucide-react";
import Sidebar from "../Components/Sidebar";

const OrderDetails = () => {
   const API_URL = process.env.REACT_APP_API_BASE_URL;
  const [bookings, setBookings] = useState([]);
  const [activeBooking, setActiveBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ LOAD BOOKINGS
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user) {
      setLoading(false);
      return;
    }

    fetch(`${API_URL}booking/GetUserBookings?customerId=${user.id}`)
      .then(res => res.json())
      .then(data => {
        setBookings(data);

        if (data.length > 0) {
          setActiveBooking(data[0]);
        }

        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  // ✅ CLICK HANDLER (MOVE SELECTED TO TOP)
  const handleSelectBooking = (booking) => {
    setActiveBooking(booking);

    const updated = [
      booking,
      ...bookings.filter(b => b.bookingId !== booking.bookingId)
    ];

    setBookings(updated);

    // ✅ SCROLL TOP (FOCUS)
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return <h3 style={{ textAlign: "center" }}>Loading bookings...</h3>;
  }

  if (!activeBooking) {
    return <h3 style={{ textAlign: "center" }}>No bookings found</h3>;
  }

  return (
    <>
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />
   <section className="booking-summary-container">
      <div className="ib_order_section_wrapper">
        <div className="ib_order_container">

          <h2 className="ib_order_main_heading">
            <CreditCard size={28} /> Booking Details
          </h2>

          {/* ================= ACTIVE BOOKING ================= */}
          <div className="ib_order_active_card">

            <div className="ib_order_active_header">
              <span style={{ fontWeight: 700 }}>
                Active Voyage • BK-{activeBooking.bookingId}
              </span>

              <span className="ib_order_status_pill">
                {activeBooking.bookingStatus}
              </span>
            </div>

            <div className="ib_order_active_body">

              <img
                src="https://images.unsplash.com/photo-1567899378494-47b22a2ae96a"
                alt="Boat"
                className="ib_order_boat_img"
              />

              <div className="ib_order_details_grid">

                {/* BOAT */}
                <div className="ib_order_data_group">
                  <label>Boat Name</label>
                  <p>
                    <Anchor size={14} />{" "}
                    {activeBooking.boats?.[0]?.boatName}
                  </p>
                </div>

                {/* DATE */}
                <div className="ib_order_data_group">
                  <label>Date & Time</label>
                  <p>
                    <Calendar size={14} />{" "}
                    {activeBooking.boats?.[0]?.bookingDate
                      ? new Date(activeBooking.boats[0].bookingDate).toLocaleDateString()
                      : "-"}
                  </p>
                  
                </div>

                {/* LOCATION */}
                <div className="ib_order_data_group">
                  <label>Boarding Point</label>
                  <p>
                    <MapPin size={14} />{" "}
                    {activeBooking.boats?.[0]?.location}
                  </p>
                </div>

                {/* TOTAL */}
                <div className="ib_order_data_group">
                  <label>Payment Total</label>
                  <p style={{ color: "#15803d" }}>
                    ₹ {activeBooking.finalAmount}
                  </p>
                  <small style={{ color: "#6b7280" }}>
                    Tax: ₹ {activeBooking.taxAmount}
                  </small>
                </div>

              </div>

              {/* ================= MULTI SLOTS ================= */}
              {activeBooking.boats?.length > 1 && (
                <div style={{ marginTop: 20 }}>
                  <h4 style={{ marginBottom: 10 }}>All Time Slots</h4>

                  {activeBooking.boats.map((b, i) => (
                    <div
                      key={i}
                      style={{
                        padding: "8px 12px",
                        background: "#f9fafb",
                        borderRadius: "6px",
                        marginBottom: "6px",
                        fontSize: "13px"
                      }}
                    >
                      {b.timeSlot} — ₹ {b.price}
                    </div>
                  ))}
                </div>
              )}

              {/* ================= ADDONS ================= */}
              {activeBooking.addons?.length > 0 && (
                <div style={{ marginTop: 20 }}>
                  <h4 style={{ marginBottom: 10 }}>Selected Add-ons</h4>

                  {activeBooking.addons.map((addon, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "8px 12px",
                        background: "#f9fafb",
                        borderRadius: "6px",
                        marginBottom: "6px",
                        fontSize: "13px"
                      }}
                    >
                      <span>
                        {addon.name} ({addon.type})
                      </span>

                      <span>× {addon.quantity}</span>

                      <span style={{ fontWeight: 600 }}>
                        ₹ {addon.price * addon.quantity}
                      </span>
                    </div>
                  ))}
                </div>
              )}

            </div>
          </div>

          {/* ================= HISTORY ================= */}
          <div className="ib_order_history_card">
            <h3 className="ib_order_subheading">Trip History</h3>

            <div className="ib_order_history_list">

              {bookings.map((trip) => (
                <div
                  key={trip.bookingId}
                  onClick={() => handleSelectBooking(trip)}
                  className={`ib_order_history_item ${
                    activeBooking.bookingId === trip.bookingId ? "active" : ""
                  }`}
                >
                  <div className="ib_order_trip_info">
                    <h4>{trip.boats?.[0]?.boatName}</h4>
                    <p>
                      BK-{trip.bookingId} •{" "}
                      {new Date(trip.createdDate).toLocaleDateString()}
                    </p>
                  </div>

                  <div className="ib_order_trip_action">

                    <div className="ib_order_status_indicator">
                      {trip.bookingStatus === "Completed" ? (
                        <CheckCircle2 size={12} />
                      ) : (
                        <AlertCircle size={12} />
                      )}
                      {trip.bookingStatus}
                    </div>

                    <span className="ib_order_price_tag">
                      ₹ {trip.finalAmount}
                    </span>

                    <ChevronRight size={18} color="#9ca3af" />
                  </div>
                </div>
              ))}

            </div>
          
          </div>

        </div>
      </div>
      
  </section>
      <Footer />
    </>
  );
};

export default OrderDetails;
